import gsap from 'gsap';
import * as $ from 'jquery';
export function burgersetup(){

        // console.log("set burger")

        // this.burgerbtn = document.getElementById("burger")
    
        // this.burgerbl = gsap.timeline()
        // this.slice = document.querySelectorAll(".link")
        // this.burgerbl.from(this.burgerbtn, 0.5, {
        //   scale: 0.5,
        //   ease: "power2.out"
        // });
    
        // this.burgerbl.from(this.slice,{duration:0.5,opacity: 0, stagger: 0.2},"-=0.5")
        // this.burgerbl.reversed(true);
        
        // this.animateIt = ()=> {
        //   this.burgerbl.reversed(!this.burgerbl.reversed());
        // }
    
        // // this.burgerbtn.removeEventListener
        // this.burgerbtn.addEventListener("click",()=>{
        //    this.animateIt()
        //    var change = this.burgerbtn;

            this.burgerbtn = document.querySelector(".burger")
            this.burgerbl = gsap.timeline()
            this.slice = document.querySelectorAll(".slice")
            this.logo = document.querySelector(".logo")
            this.credit = document.querySelector(".credit")
            this.social = document.querySelectorAll(".linksocial")
            this.linkhead = document.querySelectorAll(".linkh")

            this.burgerbtn.addEventListener("click",()=>{
                this.animateIt()
            })
        
            this.burgerbl.to("#circle", 0.5, {
              scale: 1,
              ease: "power2.out"
            });
            this.burgerbl.to([$(this.slice)],{duration:0.5,backgroundColor: "white"},"-=0.4")
            this.burgerbl.to([this.logo,this.credit,this.social],{duration:0.5,color: "white"},"-=0.5")
            this.burgerbl.to(this.slice[1],{duration:0.15,opacity: 0},"-=0.5")
            this.burgerbl.to(this.slice,{duration:0.2,top: "50%"},"-=0.5")
            this.burgerbl.to(this.slice[0],{duration: 0.2,rotateZ: 30})
            this.burgerbl.to(this.slice[2],{duration: 0.2,rotateZ: -30},"-=0.2")
            this.burgerbl.from(this.linkhead,{duration:0.3,opacity: 0, stagger: 0.2},"-=0.5")
            this.burgerbl.reversed(true)
            
            this.animateIt = ()=>{
              this.burgerbl.reversed(!this.burgerbl.reversed());
            }



        return "burger init"

}

